var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.alert.message)?_c('div',{class:`notification ${_vm.alert.type}`},[_c('button',{staticClass:"delete",on:{"click":_vm.clearAlert}}),_vm._v(" "+_vm._s(_vm.$t(_vm.alert.message))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }